import React from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../components/Navbar';

const PaymentCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#04050c] text-white">
      <Navbar />
      <div className="flex items-center justify-center h-[calc(100vh-80px)] px-4">
        <div className="text-center max-w-md">
          <div className="text-yellow-500 text-5xl mb-4">⚠</div>
          <h1 className="text-3xl font-bold mb-4">Payment Cancelled</h1>
          <p className="text-gray-400 mb-6">Your payment was not processed. Feel free to try again.</p>

          <div className="flex gap-3">
            <button
              onClick={() => navigate('/')}
              className="flex-1 px-4 py-2 bg-gray-600 hover:bg-gray-700 rounded-lg transition"
            >
              Home
            </button>
            <button
              onClick={() => navigate(-1)}
              className="flex-1 px-4 py-2 bg-cyan-500 hover:bg-cyan-600 rounded-lg transition"
            >
              Try Again
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentCancelPage;
